export default {
    login: {
        title: "MEMBER LOGIN",
        username: "ឈ្មោះគណនី | Username",
        password: "លេខសម្ងាត់ | Password",
        remember: "ចងចាំគណនី | remember me",
        submit: "Login",
        register: "Register",
        registerTitle: "Register Account",
        confirmPassword: "Confirm Password",
        currency: "Currency",
        submitRegister: "Register",
        needInputRegister: "Please fill all fields",
        backToLogin: "Back to Login",
        passwordNotMatch: "Passwords do not match",
        registerFailed: "Register failed",
        checkFailed: "Username check failed",
        needInput: "Please input username & password"
    },
    common: {
        welcome: "Welcome",
        logout: "Logout",
        lang_en: "English",
        lang_zh: "中文",
        lang_km: "ខ្មែរ"
    },
    menu: {
        news: "news",
        lotto: "Lotto",
        lottery: "Lottery",
        balance: "Balance",
        report: "Report",
        changePassword: "Change Password"
    },
    sub: {
        lotto: "Lotto",
        winResult: "Win Result",
        winResultV1: "Win Result V1",
        result: "Result"
    },
    left: {
        balances: "Balances",
        outstanding: "Outstanding",
        lastResult: "Last Result",
        currentTicket: "Current Ticket",
        previousTicket: "Previous Ticket"
    },

    lotto: {
        over: "O",            // O
        under: "U",          // U
        underover: "Under/Over",
        total: "Total",
        qian: "1000",
        liangqian: "2000",
        wuqian: "5000",
        wan: "10000",
        liangwan: "20000",
        wuwan: "50000",
        ershiwan: "200000",
        wushiwan: "500000",
        LimitBetting: "Limit Betting",
        MaxPayout: "Max Payout",
        Stake: "Stake",
        BET: "BET",
        CANCEL: "CANCEL",
        RESET: "RESET",
        rangeTitle: "Range Number",
        bettingClosed10Seconds: "Betting closed in last 10 seconds."
    },
    report: {
        No: "No",
        Date: "Date",
        Remark: "Remark",
        Turnover: "Turnover",
        ValidBet: "Valid Bet",
        NetWL: "Net W/L",
        Comm: "Comm",
        Deposit: "Deposit",
        Withdraw: "Withdraw",
        Balance: "Balance",
        Return: "Return",
        Info: "Info",
        Bet: "Bet",
        Result: "Result",
        Stack: "Stack",
        Status: "Status",
        Winlose: "Winlose"
    },
    result: {
        No: "No",
        Date: "Date",
        GetResult: "Get Result",
        Today: "Today",
        Yesterday: "Yesterday",
        Title: "Title",
        Result: "Result",
        Detail: "Detail",
        Bonus: "Bonus",
        UnderOver: "Under/Over",
        Range: "Range",
        clear: "Clear",
        weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
    },
    Balance: {
        AccountInfo: "Account Info",
        Account: "Account",
        UserName: "User Name",
        Lastlogintime: "Last login time",
        LastloginIP: "Last login IP",
        CreditInfo: "Credit Info",
        Currency: "Currency",
        CashBalance: "Cash Balance",
        Outstanding: "Outstanding",
        GivenCredit: "Given Credit",
        BetCredit: "Bet Credit"
    },
    Changepassword: {
        Changeyourpassword: "Change your password",
        OldPassword: "Old Password",
        NewPassword: "New Password",
        ConfirmPassword: "Confirm Password",
        Confirm: "Confirm",
        Clear: "Clear",
        Note: "Note",
        Note1: "New password can not be as same as the login ID;",
        Note2: "New password should be composed by 1 letter and 1 digit at least, and should not less than 6 bits.",
        Note3: "New password can not be too simple, such as aaaa1111."
    },
    footer: {
        footer: "© Copyright 2026 LOTTO8888, All rights reserved"

    },
    print: {
        issue: "Issue",
        ticketId: "Ticket",
        time: "Time",
        betType: "Bet Type",
        coef: "Coefficient",
        winlose: "Win/Lose",
    }

};
